export default __webpack_public_path__ + "static/media/Договор присоединения типовой ПУ к Justpay.2e2f9a11.docx";